import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
    useEffect(() => {
        if (process.env.NODE_ENV === "development") {
            console.info("[startup] App mounted");
        }
    }, []);

    return <AppRoutes />;
};

export default App;
